import { MonthsEnum } from '@qaroni-core/types/date/months.enum';

export const MaxDayByMonth: Record<MonthsEnum, number> = {
  [MonthsEnum.JANUARY]: 31,
  [MonthsEnum.FEBRUARY]: 29,
  [MonthsEnum.MARCH]: 31,
  [MonthsEnum.APRIL]: 30,
  [MonthsEnum.MAY]: 31,
  [MonthsEnum.JUNE]: 30,
  [MonthsEnum.JULY]: 31,
  [MonthsEnum.AUGUST]: 31,
  [MonthsEnum.SEPTEMBER]: 30,
  [MonthsEnum.OCTOBER]: 31,
  [MonthsEnum.NOVEMBER]: 30,
  [MonthsEnum.DECEMBER]: 31,
};
